// apps/client/src/state/slices/inventory.ts — keys start with "inventory" (§8.7 key rule)
import type { ItemId } from '@whiskerton/shared';
import type { SliceCreator } from '../types';
export interface InventorySlice { inventorySelected: ItemId | null; inventorySelect(id: ItemId | null): void }
// eslint-disable-next-line @typescript-eslint/no-empty-object-type -- declaration merging into GameStore
declare module '../types' { interface GameStore extends InventorySlice {} }
export const slice: SliceCreator<InventorySlice> = (set) => ({
  inventorySelected: null,
  inventorySelect: (id) => set({ inventorySelected: id }),
});
